import {Mutations} from "vuex-smart-module";
import UnitState from "@/store/modules/unit/unit-state";
import UnitData from "@/http/data/unit-data";
import UnitBlockadeData from "@/http/data/unit-blockade-data";
import _ from "lodash";
import dayjs from "dayjs";
import UnitIssueData from "@/http/data/unit-issue-data";
import AccessControlDeviceCardUnitPayload from "@/types/interfaces/access-control-device-card-unit-payload";

export default class UnitMutations extends Mutations<UnitState> {
    setUnitBlockade(unitBlockade: UnitBlockadeData): void {
        const unit = this.state.units.find(unit => unit.id === unitBlockade.unit_id);

        if (!unit) return;

        unit.blockade = unitBlockade;
    }

    setIsInitialized(value = true): void {
        this.state.isInitialized = value;
    }

    setSelectedUnitId(unitId: string): void {
        this.state.selectedUnitId = unitId;
    }

    setThoroughInspectionWhereUnitId(
        {
            unitId,
            checkedAt,
            checkedBy
        }: {
            unitId: string,
            checkedAt: Date,
            checkedBy: string
        }): void {
        const unit = _.find(this.state.units, unit => unit.id === unitId);

        if (!unit) return;

        unit.last_unit_inspection_date = dayjs(checkedAt).utc(true).toISOString();
        unit.last_unit_inspection_by = checkedBy;
    }

    setUnits(units: UnitData[]): void {
        this.state.units = units;
    }

    addUnitIssue(issue: UnitIssueData): void {
        const unit = this.state.units.find(unit => unit.id === this.state.selectedUnitId);

        if (!unit) return;

        unit.issues.push(issue);
    }

    setAccessControlDeviceCardUnit(payload: AccessControlDeviceCardUnitPayload): void {
        const {cardNumber, previousUnitId, unitId} = payload;

        if (previousUnitId) {
            const previousUnit = this.state.units.find((unit: UnitData): boolean => unit.id === previousUnitId);

            if (previousUnit) {
                previousUnit.access_control_device_cards = previousUnit.access_control_device_cards.filter(
                    (existingCardNumber: number): boolean => existingCardNumber !== cardNumber
                );
            }
        }

        if (!unitId) return;

        const unit = this.state.units.find((candidate: UnitData): boolean => candidate.id === unitId);

        if (!unit || unit.access_control_device_cards.includes(cardNumber)) return;

        unit.access_control_device_cards = [...unit.access_control_device_cards, cardNumber];
    }

    removeAccessControlDeviceCard(cardNumber: number): void {
        const unit = this.state.units.find((candidate: UnitData): boolean => {
            return candidate.access_control_device_cards.includes(cardNumber);
        });

        if (!unit) return;

        unit.access_control_device_cards = unit.access_control_device_cards.filter(
            (existingCardNumber: number): boolean => existingCardNumber !== cardNumber
        );
    }
}
